import { Observable } from 'rxjs';
import { Axios } from '@cbridge-utils/axios-observable';
import { AuthService } from '@cbridge-packages/auth';
import { logoutSubject } from '../_interceptors/RefreshTokenEngine';
import { setupErrorInterceptor } from '../_interceptors/errorInterceptor';
import { setupTokenInterceptor } from '../_interceptors/tokenInterceptor';
import { API_PREFIX } from '../apiBase.constant';

export abstract class BaseService {
  protected api: Axios;
  protected auth: AuthService;

  protected static logoutSubject = logoutSubject;

  protected constructor(apiPrefix: string, apiPath: string = '') {

    this.api = Axios.create({
      baseURL: `${import.meta.env['VITE_API_BASE_URL']}${apiPath}`.replace(API_PREFIX, apiPrefix),
      headers: { 'Content-Type': 'application/json' },
      // Backends expect repeated keys for array params (a=1&a=2), not the
      // axios default bracket style (a[]=1&a[]=2).
      paramsSerializer: { indexes: null },
    });
  }

  public setAuth(auth: AuthService) {
    this.auth = auth;
    setupErrorInterceptor(this.api, this.auth);
    if (import.meta.env.DEV) {
      setupTokenInterceptor(this.api, this.auth);
    }
  }

  logoutEvent$(): Observable<void> {
    return BaseService.logoutSubject.asObservable();
  }
}
